import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { RepresentanteSituacaoModule } from '../representante-situacao.module';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { RepresentanteSituacaoMultiselectComponent } from './representante-situacao-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        RepresentanteSituacaoModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        RepresentanteSituacaoMultiselectComponent
    ],
    exports: [
        RepresentanteSituacaoMultiselectComponent
    ]
})
export class RepresentanteSituacaoMultiselectModule { }
